export default {
  /**
   * Đơn vị dự toán cấp 1
   */
  EstimateLevelOne: 3,
  /**
   * Đơn vị kế toán trung gian 1
   */
  IntermediateAccountantFirst: 2,
  /**
   * Đơn vị kế toán trung gian 2
   */
  IntermediateAccountantSecond: 1,
};
